import {DatePipe}                           from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {CaffRecordLogIntf, CaffTypeDict}    from '@djsharkk/logr-types';
import {TableRowBase}                       from '../table-row-base';
import {TableRow}                           from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-caff',
			   imports: [
				   DatePipe
			   ],
			   templateUrl: './table-row-caff.component.html',
			   styleUrl   : './table-row-caff.component.css'
		   })
export class TableRowCaffComponent extends TableRowBase<CaffRecordLogIntf> {
	row = input.required<TableRow>();
	showDate = input(false, {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});

	protected readonly CaffTypeDict = CaffTypeDict;
}
